import { Box, Typography } from '@mui/material';
import { Nullable } from 'global';
import { formatCurrency } from 'utils';

interface Props {
  label: string;
  value: Nullable<number> | undefined;
  color?: string;
}

export const PriceField = ({ label, value, color }: Props) => (
  <Box>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography fontWeight={500} sx={color ? { color } : undefined}>
      {formatCurrency(value ?? 0, true)}
    </Typography>
  </Box>
);
